/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkOrganizationPropertyRequest
 */
export interface LinkOrganizationPropertyRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkOrganizationPropertyRequest
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkOrganizationPropertyRequest
     */
    role?: string | null;
}

/**
 * Check if a given object implements the LinkOrganizationPropertyRequest interface.
 */
export function instanceOfLinkOrganizationPropertyRequest(value: object): value is LinkOrganizationPropertyRequest {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    return true;
}

export function LinkOrganizationPropertyRequestFromJSON(json: any): LinkOrganizationPropertyRequest {
    return LinkOrganizationPropertyRequestFromJSONTyped(json, false);
}

export function LinkOrganizationPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkOrganizationPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function LinkOrganizationPropertyRequestToJSON(json: any): LinkOrganizationPropertyRequest {
    return LinkOrganizationPropertyRequestToJSONTyped(json, false);
}

export function LinkOrganizationPropertyRequestToJSONTyped(value?: LinkOrganizationPropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'role': value['role'],
    };
}

